export function matchesInvoiceSelection(row, { planId, cycle, boxOnly, boxAddon }) {
  if (!row) return false;
  if (boxOnly) return row.kind === 'BOX_ADDON';
  if (!planId) return true;
  return row.kind !== 'BOX_ADDON' && row.planId === planId && row.cycle === cycle &&
    Boolean(row.boxAddonIncluded) === Boolean(boxAddon);
}

export function isUsableUnpaidInvoice(row, now = Date.now()) {
  return row?.status === 'UNPAID' && Boolean(row.dueDate) &&
    new Date(row.dueDate).getTime() > now;
}

export function invoiceDisplayStatus(row, now = Date.now()) {
  if (row?.status === 'UNPAID' && (!row.dueDate || new Date(row.dueDate).getTime() <= now)) return 'EXPIRED';
  return row?.status || 'UNKNOWN';
}

export function chooseInvoiceForBilling(items, selection, invoiceId) {
  if (invoiceId) return items.find(row => row.id === invoiceId) || null;
  if (!selection.planId && !selection.boxOnly) return null;
  return items.find(row => isUsableUnpaidInvoice(row) && matchesInvoiceSelection(row, selection)) || null;
}

export function invoiceStatusLabel(row, text) {
  const status = invoiceDisplayStatus(row);
  if (status === 'EXPIRED') return text('期限切れ', 'Expired');
  if (status === 'CANCELED') return text('キャンセル済み', 'Canceled');
  if (status === 'PAID') return text('入金済み', 'Paid');
  if (row?.settlementStatus === 'PARTIALLY_PAID') return text('一部入金', 'Partially paid');
  if (row?.settlementStatus === 'UNDERPAID') return text(`不足入金（-${row.creditDeductionPct || 0}%）`, `Underpaid (-${row.creditDeductionPct || 0}%)`);
  if (row?.settlementStatus === 'OVERPAID') return text('超過入金', 'Overpaid');
  return text('未払い', 'Unpaid');
}
